/**
 * Lincoln MoneyGuard 2025 Pricing Configuration
 * Auto-generated from pricing model analysis
 * Generated: 2026-01-20
 *
 * This configuration contains premium band multipliers that correct for
 * Lincoln MoneyGuard 2025's non-linear pricing. Higher premiums receive
 * proportionally better rates than simple linear scaling would suggest.
 */

export const LINCOLN_MONEYGUARD_2025_BANDS = [
  { premium: 50000, multiplier: 0.9772 },
  { premium: 60000, multiplier: 0.9851 },
  { premium: 75000, multiplier: 0.9928 },
  { premium: 85000, multiplier: 0.9963 },
  { premium: 100000, multiplier: 1 },
  { premium: 115000, multiplier: 1.0027 },
  { premium: 125000, multiplier: 1.0041 },
  { premium: 150000, multiplier: 1.0068 },
  { premium: 175000, multiplier: 1.0087 },
  { premium: 200000, multiplier: 1.0102 },
  { premium: 225000, multiplier: 1.0113 },
  { premium: 250000, multiplier: 1.0122 },
  { premium: 300000, multiplier: 1.0136 },
  { premium: 350000, multiplier: 1.0146 },
  { premium: 400000, multiplier: 1.0153 },
  { premium: 500000, multiplier: 1.016 },
];
